import { createFileRoute } from '@tanstack/react-router';

import { getAppProgressOptions } from 'hooks/data/useAppProgress';
import { getDiplomaURLOptions } from 'hooks/data/useDiplomaUrl';

import { DiplomaView } from 'views/DiplomaView';

export const Route = createFileRoute('/_auth/diploma/$id')({
  component: DiplomaView,
  loader: async ({ context: { queryClient }, params }) => {
    const appProgress = await queryClient.ensureQueryData(
      getAppProgressOptions({
        resource: params.id,
      }),
    );

    const progress = appProgress?.find((p) => {
      return p.id === params.id;
    });

    if (progress?.chapterCompletion === 100) {
      return queryClient.ensureQueryData(
        getDiplomaURLOptions({
          id: params.id,
        }),
      );
    }

    return null;
  },
});
